import { render, staticRenderFns } from "./EditProvider.vue?vue&type=template&id=c336ac24&scoped=true"
import script from "./EditProvider.vue?vue&type=script&lang=js"
export * from "./EditProvider.vue?vue&type=script&lang=js"
import style0 from "./EditProvider.vue?vue&type=style&index=0&id=c336ac24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c336ac24",
  null
  
)

export default component.exports